import allcombinations from 'allcombinations'
import fuzzysort from 'fuzzysort'

export const fuzzyfilterProducts = (searchQuery, objects) => {
  let results = []
  // Generate an array with all possible search combinations
  const stopWords = ['a', 'the', 'in', 'by', '/']
  const searchArray = searchQuery
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove accents
    .replace(new RegExp('\\b(' + stopWords.join('|') + ')\\b', 'g'), '') // remove stopwords
    .replace(/\s\s+/g, ' ') // remove double spaces
    .trim() // remove trailing whitespace
    .split(' ') // split into words array
    .slice(0, 4)
  const generator = allcombinations(searchArray)

  const products = objects.map(product => {
    const cleanedBrandedName = product.brandedName.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove accents
    // Create a new object with the cleaned brandedName property and other properties copied
    return {
      ...product,
      brandedName: cleanedBrandedName
    }
  })

  // Do a search on every combination and merge results
  for (let phrase of generator) {
    results = results.concat(fuzzysort.go(phrase.join(' '), products, {
      threshold: -30000,
      keys: ['brandedName', 'barcodes']
    }))
  }

  return _.uniq(results.sort((a, b) => b.score - a.score).map(x => x.obj))
}

// export default all functions above
export default {
  fuzzyfilterProducts
}



// WEBPACK FOOTER //
// ./src/utils/functions.js